import { getLocalizedStrings } from '../../profileSettingsLocalizedStrings';
import classes from './profileEmail.scss';
import SceTextBox from '../../../Common/TextBox/sceText';
import SceButton from '../../../Common/CommonComponents/sceButton';
import ProfileEmailHelperService from './ProfileEmailHelperService';
import ReactHtmlParser from 'react-html-parser';

class ProfileEmailCard extends React.Component{

    constructor(props) {
        super(props);
        this.state = {
            unmaskedEmail: '', maskedEmail: '', editBtnClicked: false, pendingEmail: '', maskedPendingEmail: '', showPendingVerificationMsg: false,
            email: { value: '', isError: false, isValidated: false, default: '', forceValidate: false, errorMsg: '' },
        };
        this.strings = getLocalizedStrings('GeneralSettings');
        this.doURLContainsToken = false;
        this.shouldComponentRenderFlag = false;
      }

    componentWillMount() {
        let url = app.appUtil.getQueryParameters(window.location.href);
        if (url.token && url.oktaId){
          this.doURLContainsToken = true;
        }
    }

    componentDidMount = () => {  ProfileEmailHelperService.updatePrimaryEmail(this);  }

    shouldComponentUpdate = () => { return this.shouldComponentRenderFlag; }

    validateEmail = (tokenData, oktaIdData) => {// call validate email token
        ProfileEmailHelperService.validatePrimaryEmail(this, tokenData, oktaIdData);
    }

    verficationErrorHandler = (errCode) => {
        this.props.setVerficationError(errCode);
    }
    
    getProfileData = () => {
        this.shouldComponentRenderFlag = true;
        let ProfileData = app.appService.getUserInfo().profileData.profile;
        let pendingEmailArray = !_.isEmpty(ProfileData.eixSCEpendingEmail) ? ProfileData.eixSCEpendingEmail.split(';') : [];  
        let changedEmail = (!_.isEmpty(pendingEmailArray) && pendingEmailArray[1]==='L') ? pendingEmailArray[3].split('::')[0] : '';
        let maskedemail = this.getMaskedEmail(ProfileData.email);
        let showMsg = !_.isEmpty(changedEmail) ? true : false;
        let maskedPendEmail = this.getMaskedEmail(changedEmail);
        this.setState({ unmaskedEmail: ProfileData.email, maskedEmail: maskedemail, pendingEmail: changedEmail, maskedPendingEmail: maskedPendEmail, showPendingVerificationMsg: showMsg });
    }

    getMaskedEmail = (email) => {
        return email.replace(/^(...)(.*)(@.*)$/, (_, a, b, c) => a + '****' + c);
    }

    editBtnClickHandler = () => {
        window.aUtils.sendAAEvent("button","logInEmailEdit");
        this.setState({ editBtnClicked: true });
    }

    inputDataHandler = (data) => {
        if(!data.isError){
            let updatedState = { ...this.state };
            let value = data.value;
            if (data.id === "email") {
                value = value.trim();
            }
            updatedState.email.value = value;
            updatedState.email.isError = data.isError;
            updatedState.email.isValidated = data.isValidated;
            this.setState({ ...updatedState });
        }else{
            let updatedState = { ...this.state };
            let value = data.value;
            if (data.id === "email") {
                value = value.trim();
            }
            updatedState.email.value = value;
            updatedState.email.isError = data.isError;
            updatedState.email.isValidated = data.isValidated;
            this.setState({ ...updatedState });
        }
    }

    saveBtnHandler = () => {
        window.aUtils.sendAAEvent("button","editLogInSave");
        this.setState({ showSaveError: false }, ()=>{
        let updatedState = { ...this.state };
        if((!_.isEmpty(updatedState.email.value))){
            if( updatedState.email.value.toLowerCase() === updatedState.pendingEmail.toLowerCase() ){
                updatedState.email.isError = true;
                updatedState.email.errorMsg = this.strings.pendingVerficationError;
                this.setState({ ...updatedState });
            }else if( updatedState.email.value.toLowerCase() === updatedState.unmaskedEmail.toLowerCase() ){
                updatedState.email.isError = true;
                updatedState.email.errorMsg = this.strings.emailAlreadyRegisteredError;
                this.setState({ ...updatedState });
            }else{
                let emailToUpdate = updatedState.email.value;
                this.updateLoginEmail(emailToUpdate);
            }
        }else if ((_.isEmpty(updatedState.email.value)) && (!_.isEmpty(updatedState.unmaskedEmail))){
            if( updatedState.unmaskedEmail.toLowerCase() === updatedState.pendingEmail.toLowerCase() ){
                updatedState.email.isError = true;
                updatedState.email.errorMsg = this.strings.pendingVerficationError;
                this.setState({ ...updatedState });
            }else if(_.isEmpty(updatedState.pendingEmail)){
                updatedState.email.isError = true;
                updatedState.email.errorMsg = this.strings.emailAlreadyRegisteredError;
                this.setState({ ...updatedState });
            }else{
                let emailToUpdate = updatedState.unmaskedEmail;
                this.updateLoginEmail(emailToUpdate);
            }
        }
        });
    }

    updateLoginEmail = (emailToUpdate) => {
        let requestParams = {};
        requestParams.email = this.props.email;
        requestParams.changedEmail = emailToUpdate;
        let reqObj = { reqParams: requestParams };
        let updatedState = { ...this.state };
        app.profileSettingsService.updateProfileV2(reqObj).then((response) => {
            if(response.update === 'success'){ 
                updatedState.editBtnClicked = false;
                updatedState.showSaveError = false;
                updatedState.pendingEmail = emailToUpdate;
                updatedState.maskedPendingEmail = this.getMaskedEmail(emailToUpdate);
                updatedState.showPendingVerificationMsg = true;
                this.setState({ ...updatedState });
            }else if(response.errorCode === app.appUtil.getAppConstants().EXISTS_IN_OKTA){
                updatedState.email.isError = true;
                updatedState.email.errorMsg = this.strings.emailAlreadyRegisteredError;
                updatedState.showSaveError = false;
                this.setState({ ...updatedState });
            }else{
                updatedState.showSaveError = true;
                this.setState({ ...updatedState });
            }
        },(error) => {
            this.setState({ showSaveError: true });
        });
    }
    
    cancelBtnHandler = () => {
        let resetObj = { value: '', isError: false, isValidated: false, default: '', forceValidate: false, errorMsg: '' };
        let updatedState = { ...this.state };
        updatedState.email = resetObj;
        updatedState.editBtnClicked = false;
        updatedState.showSaveError = false;
        this.setState({ ...updatedState });
    }

    getViewToShow = () => {
        let warningIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_Warning.svg';
        if(this.state.editBtnClicked){
            let errorView = this.state.showSaveError ? 
                            <div className={classes.emailErrSec}>
                                <img className={classes.warningIcon} src={warningIcon} alt="Warning Icon" />
                                <p className={classes.warningMsg}>{this.strings.emailsaveError} {ReactHtmlParser(this.strings.errLink)}</p>

                            </div> : null;
            return(
                <div>
                   <div className={classes.emailLabel}>{this.strings.editEmailLabel}</div>
                   <div className={'row ' + classes.editEmailPadding}>
                        <div className='col-md-12'>
                            <div className={classes.emailTextBox}>
                                <SceTextBox 
                                    defaultValue={this.state.unmaskedEmail}
                                    id='email'
                                    type='email'
                                    validator={app.appUtil.validator}
                                    onTextUpdatedHandler={this.inputDataHandler}
                                    isError={this.state.email.isError}
                                    errorMsg={this.state.email.errorMsg}
                                    onKeyPressHandler={(e) => {
                                        if (e.key === ' ') {
                                            e.preventDefault();
                                        }
                                    }}
                                    isServiceCallReq
                                />
                            </div>
                        </div>
                    </div>
                    <div className={'row ' + classes.editEmailBtnsPadding}>
                        <div className='col-md-6'>
                            <div className={classes.emailSaveBtn}>
                                <SceButton
                                    id='Save'
                                    buttonType='default'
                                    value={this.strings.save}
                                    onClick={this.saveBtnHandler}
                                />
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className={classes.emailCancelBtn}>
                                <SceButton
                                    id='Cancel'
                                    buttonType='default'
                                    onClick={this.cancelBtnHandler}
                                    value={this.strings.cancel}
                                />
                            </div>
                        </div>
                    </div>
                    {errorView}
                </div>
            );
        }else{
            let pendingMsg = this.state.showPendingVerificationMsg ? 
                            <div className={classes.emailErrSec}>
                                <img className={classes.warningIcon} src={warningIcon} alt="Warning Icon" />
                                <p className={classes.pendingMsg}>{this.strings.pendingVerificationMsg1}<strong>{this.state.maskedPendingEmail}</strong>{this.strings.pendingVerificationMsg2}</p>
                            </div> : null;
            return(
                <div>
                    <div className={classes.emailLabel}>{this.strings.emailLabel}</div>
                    <div className={classes.editButtonPadding}><button className={classes.editButton} id="logInEmail" onClick={this.editBtnClickHandler} >{this.strings.editBtn}</button></div>
                    <div className={classes.emailContent}>{this.state.maskedEmail}</div>
                    {pendingMsg}
                </div>
            );
        }
    }

    render(){
        let view = this.getViewToShow();
        return(
            <div className={classes.Card}>
                {view}
            </div>
        );
    }
}

export default ProfileEmailCard;